import { render } from "./EditIcon.vue?vue&type=template&id=0703fa40&ts=true"
import script from "./EditIcon.ts?vue&type=script&lang=ts"
export * from "./EditIcon.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__